import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute } from "@tanstack/react-router";
import ClubHub from "@/pages/ClubHub";
import { MainLayout } from "@/components/layout/MainLayout";
import { readable, socialMeta } from "@/lib/routeSocial";

export const Route = createFileRoute("/clubs/$slug")({
  head: ({ params }) => {
    const name = readable(params.slug);
    return {
      scripts: entityScripts({ type: "SportsTeam", name: name, path: `/clubs/${params.slug}`, crumbs: [{ name: "Clubs", path: "/clubs" }, { name: name, path: `/clubs/${params.slug}` }], extra: { sport: "Association football" } }),
      meta: socialMeta({
        seo: { topics: ["teams", "footballPredictions"], entities: [readable(params.slug)] },
        title: `${name} Predictions & Betting Tips | Statlign`,
        description: `${name} match predictions, value odds and betting tips backed by recent form and our 50-strategy analysis engine.`,
      }),
    };
  },
  component: () => (
    <MainLayout>
      <ClubHub />
    </MainLayout>
  ),
});
